export default "/images/55ce3ce0ebabf1db628ccc78b8a84dab.avif";